import { AnyQuestionI } from "services/shortAnswerService/question-types/Question";
import { isCalculationQuestion } from "services/shortAnswerService/question-types/typeGuards";

import { questionHasAutoMarking } from "seneca-common/features/exam-questions/utils";

export default function isQuestionAiMarked(question: AnyQuestionI) {
  // CALC-TODO - remove this when we will have auto-marking for calculations
  return questionHasAutoMarking(question) || isCalculationQuestion(question);
}
